import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SkyLocalStorageService } from '@skyeng/libs/shared/local-storage';

const SIDEBAR_STATE_KEY = 'wfm-admin-sidebar-hidden';

@Component({
  selector: 'crm-layout-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPageComponent {
  isHidden = true;

  toggleIcon = require('!html-loader!image-webpack-loader?{}!./images/hide.svg').default;

  constructor(private readonly skyLocalStorageService: SkyLocalStorageService) {
    this.isHidden = !!+this.skyLocalStorageService.get(SIDEBAR_STATE_KEY);
  }

  toggleMenu(): void {
    this.isHidden = !this.isHidden;
    this.skyLocalStorageService.set(SIDEBAR_STATE_KEY, +this.isHidden);
  }
}
